import { Stripe } from 'stripe';
export interface CompanySettings {
    name: string;
    integrations: Integrations;
}

export interface BubbleConfig {
    apiKey: string;
    appName: string;
    dataType?: string;
    syncCheckout: boolean;
    matchOnCustomerId?: boolean;
    encryptMatchId?: boolean;
    customFields?: { bubbleField: string; value: keyof Stripe.Subscription }[];
}

export interface PaypalConfig {
    testClientId?: string;
    liveClientId: string;
}

export interface RewardfulConfig {
    apiKey: string;
}

export interface Integrations {
    bubble?: BubbleConfig[];
    paypal?: PaypalConfig;
    rewardful?: RewardfulConfig;
}

export enum Integration {
    BUBBLE = 'bubble',
    PAYPAL = 'paypal',
    REWARDFUL = 'rewardful',
}
